// import {
// 	Dialog,
// 	DialogActions,
// 	DialogContent,
// 	DialogContentText,
// 	DialogTitle,
// 	Button,
// } from '@mui/material';

// export default function ConfirmDeleteDialog({ open, onClose, onConfirm }: any) {
// 	return (
// 		<Dialog open={open} onClose={onClose}>
// 			<DialogTitle>Delete Coupon</DialogTitle>
// 			<DialogContent>
// 				<DialogContentText>
// 					Are you sure you want to delete this coupon? This action cannot be undone.
// 				</DialogContentText>
// 			</DialogContent>
// 			<DialogActions>
// 				<Button onClick={onClose}>Cancel</Button>
// 				<Button color="error" variant="contained" onClick={onConfirm}>
// 					Delete
// 				</Button>
// 			</DialogActions>
// 		</Dialog>
// 	);
// }

import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Button,
} from '@mui/material';

export default function ConfirmDeleteDialog({ open, onClose, onConfirm }: any) {
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>Delete Coupon</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Are you sure you want to delete this coupon? This action cannot be undone.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button color="error" variant="contained" onClick={onConfirm}>
					Delete
				</Button>
			</DialogActions>
		</Dialog>
	);
}
